module.exports = __webpack_public_path__ + "static/bg-3a89138d58c93dbc55d4cf07d4bde53a.png";